"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArrayConcatenateNode = void 0;
const BaseNode_1 = require("../../BaseNode");
const Schema = __importStar(require("./schema.json"));
const NODE_TYPE = 'ARRAY-CONCAT';
class ArrayConcatenateNode extends BaseNode_1.BaseNode {
    constructor() {
        super(...arguments);
        this._resolve = (params) => {
            const { array1, array2 } = params;
            let newArray = [];
            if (Array.isArray(array1)) {
                newArray = [...array1];
            }
            if (Array.isArray(array2)) {
                newArray = [...newArray, ...array2];
            }
            return {
                [`output`]: newArray,
            };
        };
        this._interfaceDefinition = Schema;
    }
    // we override the schema definition here so that we can provide it based on the selected value
    get interfaceDefinition() {
        this.config.type = this.config.type || 'Photo';
        //set up the basic outputParams schema
        const OutputParams = {
            type: 'object',
            properties: {
                output: {
                    items: BaseNode_1.BaseNode.getProp(this.config.type, 'Item'),
                    description: 'Combined items',
                    type: 'array',
                    title: 'input',
                },
            },
        };
        const InputParams = {
            type: 'object',
            properties: {
                array1: {
                    items: BaseNode_1.BaseNode.getProp(this.config.type, 'Item'),
                    description: 'Array 1',
                    type: 'array',
                    title: 'array1',
                },
                array2: {
                    items: BaseNode_1.BaseNode.getProp(this.config.type, 'Item'),
                    description: 'Array 2',
                    type: 'array',
                    title: 'array2',
                },
            },
        };
        const ConfigParams = {
            type: 'object',
            properties: {
                type: BaseNode_1.BaseNode.getTypeOptions(false),
            },
        };
        return Object.assign(Object.assign({}, Schema), { InputParams: InputParams, OutputParams: OutputParams, ConfigParams: ConfigParams });
    }
}
exports.ArrayConcatenateNode = ArrayConcatenateNode;
ArrayConcatenateNode._nodeDefinition = {
    NODE_TYPE,
    defaultTitle: 'Array Combine',
    isIdempotent: true,
    primaryCategory: 'Collection',
};
//# sourceMappingURL=ArrayConcatenate.js.map